import { render } from "./vdvcordercensusdetail.vue?vue&type=template&id=5329be3d&scoped=true"
import script from "./vdvcordercensusdetail.vue?vue&type=script&lang=js"
export * from "./vdvcordercensusdetail.vue?vue&type=script&lang=js"

import "./vdvcordercensusdetail.vue?vue&type=style&index=0&id=5329be3d&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5329be3d"]])

export default __exports__